import types from "../actionTypes";

export const setTab = (payload, { init } = { init: false }) => ({
  type: types.SET_SELECTED_TAB,
  payload,
  init,
});
